export default __webpack_public_path__ + "static/media/icon_star-outlined.0688ce08.svg";